var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',_vm._g({ref:"editable",staticClass:"editable",attrs:{"contenteditable":""},on:{"focus":_vm.onFocus}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }